/**
 * ViewExportProvider — holds the current representation's export actions so a
 * headerless tabular surface (the container) can publish them and the sibling
 * {@link ViewReprChrome} can render them. Wraps the non-board block in
 * ViewerComposition (chrome + container together).
 */
import { useMemo, useState, type ReactNode } from "react";
import { ViewExportContext, type ViewExportContextValue } from "./ViewExportContext.js";
import type { ViewExportAction } from "./export/ViewExportMenu.js";

export function ViewExportProvider({ children }: { readonly children: ReactNode }): ReactNode {
  const [actions, setActions] = useState<readonly ViewExportAction[]>([]);
  const value = useMemo<ViewExportContextValue>(() => ({ actions, setActions }), [actions]);
  return <ViewExportContext.Provider value={value}>{children}</ViewExportContext.Provider>;
}
